// Inspection describes existing runtime permissions; it never authorizes an action.
const tablePattern = /^[a-zA-Z][a-zA-Z0-9_]*$/
const realId = value => /^[1-9]\d*$/.test(String(value == null ? '' : value))

export function inspectionCreator(row, table) {
  if (!row || typeof row !== 'object') return undefined
  const keys = tablePattern.test(table || '') ? [table + 'Created_by', 'created_by'] : ['created_by']
  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(row, key) && realId(row[key])) return Number(row[key])
  }
  return undefined
}

export function actionInspectionChecks(action) {
  return action && realId(action.id) ? [{ core: 'actions', id: action.id }] : []
}

export function fieldInspectionChecks(field, row, checkTable = true) {
  if (!field || !realId(field.id)) return []
  const checks = [{ core: 'showfields', id: field.id }, { core: 'modfields', id: field.id }]
  if (checkTable && tablePattern.test(field.table || '')) {
    const creator = inspectionCreator(row, field.table)
    checks[1].table = field.table
    if (creator !== undefined) checks[1].created_by = creator
  }
  return checks
}

export function tableInspectionChecks(table, operations, row) {
  if (!tablePattern.test(table || '')) return []
  const creator = inspectionCreator(row, table)
  return operations.filter(operation => ['watch', 'insert', 'update', 'delete', 'export'].includes(operation)).map(id => {
    const check = { core: 'table_' + table, id }
    if (creator !== undefined) check.created_by = creator
    return check
  })
}
